export enum BusinessSortField {
  CreatedAt = "createdAt",
}

const BUSINESS_SORT_FIELD_VALUES = new Set<string>(
  Object.values(BusinessSortField)
);

export function isBusinessSortField(value: string): value is BusinessSortField {
  return BUSINESS_SORT_FIELD_VALUES.has(value);
}
